import styled from 'styled-components';

const Wrapper = styled.div`
  text-align: left;
`;

export default Wrapper;